if (!customElements.get("variant-additional-note")) {
  customElements.define(
    "variant-additional-note",
    class VariantAdditionalNote extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.section = this.closest("section");
        this.section?.addEventListener("variantChangeEnd", (event) => {
          const picker = event.target.closest("variant-options") || event.target;
          const variantId = picker.currentVariant?.id || picker.dataset.variantId;
          if (variantId) this.updateForVariant(String(variantId));
        });
        this.section?.addEventListener("variantProductInfoRendered", (event) => {
          const variantId = event.detail?.variant?.id;
          if (variantId) this.updateForVariant(String(variantId));
        });
        this.updateForVariant(String(this.dataset.selectedVariantId || ""));
      }

      updateForVariant(variantId) {
        let visibleNote = null;
        this.querySelectorAll("[data-additional-note-for]").forEach((note) => {
          const show = note.dataset.additionalNoteFor === variantId;
          note.hidden = !show;
          if (show) visibleNote = note;
        });
        this.hidden = !visibleNote;
      }
    }
  );
}
